import HttpClient from './HttpClient';

const PagosService = {
  getPagos: (folioCredito) => {
    const path = `credit/pagos/${folioCredito}`;
    return HttpClient.get(path, {}, true, true);
  },
  getAmortizacion: (folioCredito) => {
    const path = `credit/pagos/amortizacion/${folioCredito}`;
    return HttpClient.get(path, {}, true, true);
  },
  savePagos: (folioCredito, form) => {
    const path = `credit/pagos/${folioCredito}`;
    return HttpClient.post(path, form, true, true);
  },
  deletePago: (idPago, params) => {
    const path = `credit/pagos/${idPago}`;
    return HttpClient.delete(path, params, true, true);
  },
  saveCompromiso: (params) => {
    const path = `credit/pagos/compromiso`;
    return HttpClient.post(path, params, true, true);
  }
};

export default PagosService;
